import userStore from '~/redux/user/store'


export const getSvodRedirect = () => {
    const user = userStore.getState().user
    return user && user.redirectUrl
}